const SubscriptionSupportIcon = ({ size = 24, color = '#32C05A', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M9.4668 9.5332C11.28 10.0633 17.0667 11.8683 20.5029 12.9453C20.6949 13.0058 20.7415 13.2639 20.5732 13.3867C19.7463 13.9902 19.1383 14.4226 18.7393 14.6621L17.915 15.1562L20.6006 17.8418C20.977 18.2184 20.9772 18.8335 20.6006 19.21H20.5996L19.1436 20.666C18.9565 20.8534 18.7101 20.9481 18.46 20.9482H18.459C18.2101 20.9486 17.9621 20.8543 17.7734 20.666L15.7695 18.6611L15.0908 17.9824L14.5967 18.8057C14.3461 19.2233 13.9122 19.8399 13.2754 20.7119C13.1576 20.8727 12.9352 20.8264 12.8799 20.6533C11.8218 17.3426 9.99725 11.3616 9.4668 9.5332Z"
                stroke={color}
                strokeWidth="1.5"
            />
            <path
                d="M10 5V2M13.5 6.5L16 4M6.5 13.5L4.5 15.5M5 10H2M6.5 6.5L4.5 4.5"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default SubscriptionSupportIcon
